var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-html"},[_c('BaseJson',{attrs:{"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff594110","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditJson.vue
// module id = 652
// module chunks = 0